export type RegisterStep =
  | 'auth'
  | 'hunterProfile'
  | 'roleSelection'
  | 'featurePage'
  | 'orgForm'
  | 'checkout'
  | 'crewExplainer'
  | 'crewName'

export type { CreateOrgType as OrgType } from '@/shared/domain'

export type BillingCycle = 'monthly' | 'annual'

export type HunterProfileData = {
  firstName: string
  lastName: string
  contactValue: string
  phoneE164: string | null
  flywayRegion: string
  profilePhotoUrl: string
}

export type OrgFormData = {
  orgName: string
  state: string
  country: string
  promoCode: string
  promotionCodeId?: string
}

export type RegisterPhase = 1 | 2 | 3 | 4

export const REGISTER_TOTAL_PHASES = 4

export const STEP_TO_PHASE: Record<RegisterStep, RegisterPhase> = {
  auth: 1,
  hunterProfile: 1,
  roleSelection: 2,
  featurePage: 2,
  orgForm: 3,
  checkout: 4,
  crewExplainer: 2,
  crewName: 3,
}

export const REGISTER_PROGRESS_STORAGE_KEY = 'register_progress'
export const REGISTER_OTP_STATE_STORAGE_KEY = 'register_otp_state'

export const CREATE_CREW_FLOW = 'create-crew'
